import Swiper, { A11y, Autoplay, Navigation } from 'swiper';
import BaseComponent from '../base/baseComponent';
import analytics from '@common/utils/analytics';
import { getId } from '@common/utils/brandDiffsUtils';
import customEventBus from '../libs/eventBus';
Swiper.use([Navigation, Autoplay, A11y]);
const SESSIONSTORAGE_KEY = 'ti_re';
export default class HeaderTickerComponent extends BaseComponent {
    constructor(element) {
        super(element);
        this.init();
    }
    get Messages() {
        return {
            [this.CUSTOM_MESSAGES.BREAKPOINTER.BREAKPOINT_CHANGE]: this.onBreakpointChange,
        };
    }
    init() {
        var _a;
        this.$carouselContainer = this.$el.querySelector('.swiper-container');
        this.slides = this.$el.querySelectorAll('.swiper-slide');
        this.moltiplicatorTiming = ((_a = this.slides) === null || _a === void 0 ? void 0 : _a.length) > 1 ? 16 : 1;
        if (this.slides.length > 0) {
            this.listenForResize();
            this.handleTickerClose();
            if (this.slides.length > 1) {
                this.initSlider();
                this.$button.classList.add('d-none');
            }
            else {
                this.$button.classList.add('d-block');
                this.$el.classList.add('single-slide');
                if (this.slides[0].dataset.color && this.slides[0].dataset.bgcolor) {
                    this.$el.style.setProperty('--ticker-color', this.slides[0].dataset.color);
                    this.$el.style.setProperty('--ticker-bgcolor', this.slides[0].dataset.bgcolor);
                }
            }
        }
        // analytics [OE-16592]
        const messageWrapper = this.$el.querySelectorAll('.message-wrapper[data-analytics-title]');
        messageWrapper.forEach((el) => {
            const linkText = el.querySelector('a');
            if (linkText) {
                const analyticsTitle = linkText.closest('.message-wrapper').getAttribute('data-analytics-title');
                linkText.addEventListener('click', (e) => analytics.topTicker(window.datalayerdata.pageCategory, analyticsTitle, window.loggedin ? 'enter' : 'logged'));
            }
        });
    }
    listenForResize() {
        let timerId;
        this.handleLongMessagesSwipe();
        window.addEventListener('resize', () => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                console.info('debounced listenForLongMessages');
                this.handleLongMessagesSwipe();
            }, 100);
        });
    }
    handleLongMessagesSwipe() {
        const messages = this.$el.querySelectorAll('.message');
        messages.forEach((msg) => {
            if (msg.offsetWidth > msg.parentElement.offsetWidth) {
                msg.style.setProperty('transition-duration', `${(msg.offsetWidth - msg.parentElement.offsetWidth) * this.moltiplicatorTiming}ms`);
                msg.classList.add('swipe-animation');
            }
            else {
                msg.classList.remove('swipe-animation');
            }
        });
        this.slides.forEach((slide) => {
            const messages = slide.querySelectorAll('.message');
            messages.forEach((msg, i) => {
                var _a;
                if ((!this.isDesktop && i === messages.length - 1) || (this.isDesktop && i === 0)) {
                    if (msg.offsetWidth > msg.parentElement.offsetWidth) {
                        ((_a = this.slides) === null || _a === void 0 ? void 0 : _a.length) > 1 && slide.style.setProperty('--animation-delay', `${(msg.offsetWidth - msg.parentElement.offsetWidth) * this.moltiplicatorTiming + 5400}ms`);
                        slide.dataset.swiperAutoplay = `${(msg.offsetWidth - msg.parentElement.offsetWidth) * this.moltiplicatorTiming + 6000}`;
                    }
                }
            });
        });
    }
    animateSlides(swiper) {
        var _a;
        this.$el.style.setProperty('--ticker-color', this.slides[swiper.realIndex].dataset.color);
        this.$el.style.setProperty('--ticker-bgcolor', this.slides[swiper.realIndex].dataset.bgcolor);
        const messages = this.slides[swiper.activeIndex].querySelectorAll('.message');
        messages.forEach((msg, i) => {
            if (msg.offsetWidth > msg.parentElement.offsetWidth) {
                msg.style.setProperty('transform', `translate3d(-${msg.offsetWidth - msg.parentElement.offsetWidth}px, 0, 0)`);
            }
        });
        const previousMessages = (_a = this.slides[swiper.previousIndex]) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.message');
        previousMessages === null || previousMessages === void 0 ? void 0 : previousMessages.forEach((previousMsg) => {
            if (previousMsg.offsetWidth > previousMsg.parentElement.offsetWidth) {
                const translateDuration = previousMsg.style.getPropertyValue('translate-duration');
                previousMsg.style.setProperty('translate-duration', '0s');
                previousMsg.style.setProperty('transform', `translate3d(0, 0, 0)`);
                previousMsg.style.setProperty('translate-duration', translateDuration);
            }
        });
    }
    onBreakpointChange(br) {
        // this.$log(br);
        if (br.value >= window.mqObj['md'] && !this.isDesktop) {
            this.isDesktop = true;
        }
        else if (br.value < window.mqObj['md'] && this.isDesktop) {
            this.isDesktop = false;
        }
    }
    initSlider() {
        this.carousel = new Swiper(this.$carouselContainer, {
            allowTouchMove: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            speed: 0,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            rewind: true,
            a11y: {
                enabled: true,
                prevSlideMessage: this.$options.prevslidemessage,
                nextSlideMessage: this.$options.nextslidemessage,
                firstSlideMessage: this.$options.firstslidemessage,
                lastSlideMessage: this.$options.lastslidemessage,
                paginationBulletMessage: this.$options.paginationbulletmessage.replace('INDEX_NUMBER', '{{index}}'),
            },
            on: {
                afterInit: (swiper) => {
                    this.animateSlides(swiper);
                    if (getId() === 'ST') {
                        customEventBus.emit('header:updatescroll', () => { });
                    }
                },
                slideChange: (swiper) => {
                    this.animateSlides(swiper);
                },
            },
        });
    }
    removeTicker() {
        document.querySelector('body').classList.remove('has-ticker');
        this.$el.classList.add('close');
        setTimeout(() => {
            this.$el.remove();
            this.onAfterRemoveTicker();
        }, 300);
    }
    onAfterRemoveTicker() {
        var _a;
        (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem(SESSIONSTORAGE_KEY, '1');
    }
    handleTickerClose() {
        this.$button = this.$el.querySelector('.icon--close-white');
        this.$on('keydown', (e) => {
            if (e.key == ' ') {
                e.preventDefault();
                this.removeTicker();
            }
        }, this.$button);
        this.$on('click', () => {
            this.removeTicker();
        }, this.$button);
    }
}
